var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("navigation-layout", { ref: "navigationlayout" }, [
    _c("h1", { attrs: { slot: "title" }, slot: "title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { slot: "abstract" }, slot: "abstract" }, [
      _vm._v(_vm._s(_vm.abstract))
    ]),
    _vm._v(" "),
    _c("main", [
      _c(
        "div",
        { staticClass: "md-layout", attrs: { id: "integratorlist" } },
        _vm._l(_vm.integrators, function(integrator, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass:
                "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
            },
            [
              _c(
                "md-list",
                [
                  _c("md-list-item", [
                    _c(
                      "div",
                      { staticClass: "md-list-item-text" },
                      [
                        _c("span", {
                          domProps: { textContent: _vm._s(integrator.name) }
                        }),
                        _vm._v(" "),
                        _vm._l(integrator.trustedDomains, function(
                          trustedDomain,
                          indextrusted
                        ) {
                          return _c("span", {
                            key: indextrusted,
                            domProps: { textContent: _vm._s(trustedDomain) }
                          })
                        })
                      ],
                      2
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ac2082c", { render: render, staticRenderFns: staticRenderFns })
  }
}